<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a>JESUS WAS A LIBERAL</h1>
<p class="front">RECLAIMING<br/>CHRISTIANITY<br/>FOR ALL</p>
<p class="author"><em>Rev. Scotty McLennan</em></p>
<p class="image1"><img alt="Image" src="images/fiii-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230240582_03_title.vue?64eebcc7